<div class="api-switcher" *ngIf="showEnabled" [class.expanded]="isExpanded">
  <!-- Badge flottant -->
  <div class="switcher-badge" (click)="isExpanded = !isExpanded"
       [class.php]="isPhp" [class.nodejs]="!isPhp">
    <span class="badge-icon">{{ isPhp ? 'PHP' : 'JS' }}</span>
  </div>

  <!-- Panel détail -->
  <div class="switcher-panel" *ngIf="isExpanded">
    <div class="panel-title">Source API</div>
    <div class="panel-options">
      <button class="option-btn"
              [class.active]="isPhp"
              (click)="switchTo('php')">
        <span class="option-dot php-dot"></span>
        PHP Slim
      </button>
      <button class="option-btn"
              [class.active]="!isPhp"
              (click)="switchTo('nodejs')">
        <span class="option-dot nodejs-dot"></span>
        Node.js
      </button>
    </div>
    <div class="panel-url">{{ activeUrl }}</div>
  </div>
</div>
